import { segmentTrackAction } from 'lib/segment'
import { EVENT } from 'lib/segment/const'
import StateStorage from 'lib/state-storage'

const user = StateStorage.getAuthUser()
const id_customer = user?.id_customer

export const segmentBannerViewEvent = ({ ref_id, ref_type }) => {
  const data = {
    ref_id: Number(ref_id),
    ref_type,
  }
  segmentTrackAction(EVENT.bannerViewEvent, data)
}

export const segmentBannerClickEvent = ({ ref_id, ref_type, cta_type }) => {
  const data = {
    ref_id: Number(ref_id),
    ref_type,
    cta_type,
  }
  segmentTrackAction(EVENT.bannerClickEvent, data)
}

export const segmentBannerTaggedProductsClicked = ({ ref_id, ref_type }) => {
  const data = {
    ref_id: Number(ref_id),
    ref_type,
  }
  segmentTrackAction(EVENT.bannerTaggedProductsClicked, data)
}

export const segmentFeaturedCellClicked = ({
  ref_id,
  cta_type,
  position,
  position_type,
}) => {
  const data = {
    id_customer,
    ref_id,
    cta_type,
    position,
    position_type,
  }
  segmentTrackAction(EVENT.featuredCellClicked, data)
}
